export default __webpack_public_path__ + "static/media/6.e1c3d259.jpg";